define('container/moduleLoaders/StructuredArgLoader',['underscore', 'bluebird'], function(_, Promise) {

    'use strict';

    function concatObject(object, item, key) {
        object[key] = item;
        return object;
    }

    function concatArray(array, item) {
        return array.concat(item);
    }

    function mapLeaves(tree, mapFn) {

        var baseIterable,
            concatFn;

        if (_.isArray(tree)) {

            baseIterable = [];
            concatFn = concatArray;

        } else if (_.isObject(tree)) {

            baseIterable = {};
            concatFn = concatObject;

        } else {
            return mapFn(tree);
        }

        return _.reduce(
            tree,
            function(memo, item, key) {
                return concatFn(memo, mapLeaves(item, mapFn), key);
            },
            baseIterable
        );

    }

    /**
     * Use this to define a tree structure where all leaf nodes will be resolved as args
     *
     * Service definition usage examples:
     *
     *      {
     *          structuredArg: {
     *              key: '@arg1',
     *              more: ['@arg2', '%arg3']
     *          }
     *      }
     *
     * The above will resolve all args using any configured arg resolvers before returning
     */
    function StructuredArgLoader() {
    }

    StructuredArgLoader.prototype.canLoadModule = function(extensionApi) {
        return !!extensionApi.serviceDefinition.structuredArg;
    };

    StructuredArgLoader.prototype.canInitialise = function(extensionApi) {
        return !!extensionApi.serviceDefinition.structuredArg;
    };

    StructuredArgLoader.prototype.initialise = function(instanceCreatedCallback, loadedModule) {
        return loadedModule;
    };

    StructuredArgLoader.prototype.loadModule = function(extensionApi) {

        var args = [],
            placeholders;

        placeholders = mapLeaves(extensionApi.serviceDefinition.structuredArg, function(arg) {
            args.push(arg);
            return args.length - 1;
        });

        return Promise.all(extensionApi.resolveArgs(args)).then(function(resolvedArgs) {

            return mapLeaves(placeholders, function(placeholder) {
                return resolvedArgs[placeholder];
            });

        });

    };

    return StructuredArgLoader;
});

